import { SetMyBankAccountRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useSetClientBankAccount() {
  const api = useApi();
  const [saving, setSaving] = useState(false);

  // PortalUser omitted: no earthnode handler for this endpoint reads it (verified against
  // lib/www/routes/v2/bank_account.php) — the backend takes the user from the JWT.
  async function setClientBankAccount(params: Omit<SetMyBankAccountRequest, 'PortalUser'>) {
    try {
      setSaving(true);
      const res = await api.postSetMyClientBankAccount(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSaving(false);
    }
  }

  return { saving, setClientBankAccount };
}
